import {
  FormControl,
  InputGroup,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react'
import React from 'react'
import { FormLabel } from './FormLabel'
import { Input } from './Input'

interface LabeledRightIconProps extends InputProps {
  icon?: JSX.Element
  fontWeight?: string
  label: string
  size?: 'sm' | 'md'
}

export const LabeledRightIconInput = ({
  fontWeight = 'regular',
  icon,
  isDisabled,
  isInvalid,
  isRequired,
  label,
  placeholder,
  size = 'md',
  ...baseProps
}: LabeledRightIconProps) => {
  const iconSize = size === 'sm' ? '8' : '10'
  return (
    <FormControl isRequired={isRequired}>
      <FormLabel fontWeight={fontWeight}>{label}</FormLabel>
      <InputGroup>
        {icon && (
          <InputRightElement color="gray.500" boxSize={iconSize}>
            {icon}
          </InputRightElement>
        )}
        <Input
          paddingRight="7"
          placeholder={placeholder}
          isDisabled={isDisabled}
          isInvalid={isInvalid}
          size={size}
          {...baseProps}
        />
      </InputGroup>
    </FormControl>
  )
}
